export const apartmentsGlobalSettings = {
  header: {
    title: "الإعدادات العامة",
    sub: "ينطبق على <strong>{count} شقة</strong> في حسابك. | ينطبق على <strong>{count} شقق</strong> في حسابك.",
    globalChip: "عام",
  },
  sections: {
    activate: "تفعيل محرّك الحجز",
    payment: "متى يدفع النزيل؟",
    hold: "مدة الحجز المؤقت",
    request: "وضع الطلب",
    link: "رابط للمشاركة",
  },
  motor: {
    activeTitle: "المحرّك مُفعّل",
    inactiveTitle: "المحرّك مُعطّل",
    activeDesc: "يمكن للنزلاء الحجز مباشرةً عبر رابطك.",
    inactiveDesc: "الحجوزات المباشرة مُعطّلة لجميع شققك.",
    statusOn: "مُفعّل",
    statusOff: "مُعطّل",
  },
  payment: {
    onArrival: {
      name: "الدفع عند الوصول",
      hint: "احجز مجانًا وادفع عند الوصول.",
    },
    online: {
      name: "الدفع عبر الإنترنت",
      hint: "ادفع عند تأكيد الحجز.",
    },
  },
  common: {
    saving: "جارٍ الحفظ…",
    onlyOnlineBadge: "الدفع عبر الإنترنت فقط",
  },
  hold: {
    desc: "يُحجب التقويم أثناء إتمام النزيل للدفع.<br>إذا لم يدفع خلال المدة المحدّدة، <strong>يُحرَّر التوفّر تلقائيًا</strong>.",
  },
  units: {
    min: "دقيقة",
    hour: "ساعة",
    hours: "ساعات",
  },
  request: {
    enabledTitle: "الطلبات مُفعّلة",
    autoTitle: "تأكيد تلقائي",
    enabledDesc: "يرسل النزيل طلبًا، وأنت توافق عليه أو ترفضه عبر واتساب.",
    autoDesc: "يُؤكَّد الحجز تلقائيًا عند إتمام الدفع.",
    tagControl: "أنت تتحكّم بمن يحجز",
    tagWhatsapp: "واتساب عند استلام الطلب",
  },
  link: {
    desc: "الرابط نفسه لجميع شققك. شاركه في نبذتك أو حملاتك أو رسائلك التلقائية.",
    copyTitle: "نسخ",
    viewVisitor: "عرض كزائر",
    shareWhatsapp: "المشاركة عبر واتساب",
  },
  callout: "اختر شقة من الشريط الجانبي لضبط <strong>الأسعار</strong> و<strong>العروض</strong> و<strong>الرسوم</strong> بشكل فردي.",
  savebar: {
    unsaved: "تغييرات غير محفوظة في مدة الحجز ووضع الطلب",
    save: "حفظ الإعدادات",
  },
  toasts: {
    paymentUpdated: "تم تحديث طريقة الدفع.",
    paymentError: "تعذّر حفظ طريقة الدفع.",
    saved: "تم حفظ الإعدادات.",
    saveError: "تعذّر الحفظ.",
    linkCopied: "تم نسخ الرابط.",
    copyError: "تعذّر النسخ.",
  },
  share: {
    whatsappText: "مرحبًا 👋 أشاركك رابط الحجز: {link}",
  },
};
